export default __webpack_public_path__ + "static/media/menu-tiers.42919ad7.svg";